import React, {Component} from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Copyright from './components/Bottom'
import compose from 'recompose/compose';
//import {SideBarListItems}  from './components/SideBarListItems'
import styles from './styles';
import Base from './components/content/Base'
import Header from './components/Header'


class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.myCallback = this.myCallback.bind(this);
    this.state = {
      dataObjective:null
    }
  }

  myCallback = (dataFromChild) => {
    
    this.setState({
      dataObjective: dataFromChild,
    });
  }

  render() {
    const {dataObjective}=this.state
    const {classes}=this.props
    if(dataObjective===null){
      return (
        <div className={classes.root}>
        <CssBaseline />
          <AppBar >
              <Toolbar className={classes.toolbar}>
                <Header  callbackFromParent={this.myCallback}/>
              </Toolbar>
          </AppBar>
        </div>
    );
    }else{
      
      return (
        <div className={classes.root}>
          <CssBaseline />
            <AppBar >
                <Toolbar className={classes.toolbar}>
                <Header  callbackFromParent={this.myCallback}/>
                </Toolbar>
            </AppBar>
        
          <main className={classes.content}>
              <div className={classes.appBarSpacer} />
                <Container maxWidth="xl" className={classes.container}>
                  <Grid container spacing={1}>
                      <Grid item  lg={12}>
                        <Paper>
                          <Base data={dataObjective} interval={10000}/>
                        </Paper>
                      </Grid>
                  </Grid>
                  <Box pt={4}>
                      <Copyright />
                  </Box>
                </Container>
          </main>
        </div>
    );
    }
  }
}
export default
  compose(withStyles(styles))(Dashboard);